export default {
    loginAction(context, token, ) {
        context.commit('changeLogin', token);
    },
    meteoTokenAcxtion(context, token) {
        context.commit('changeMeteoToken', token);
    }
}